import { createModel } from '@rematch/core';
import { IAPICall } from 'rematch/interfaces';
import { RootModel } from '.';

export const request = createModel<RootModel>()({
	state: {},
	reducers: {},
	effects: (dispatch) => ({
		async anonymousRequest(payload: IAPICall, store) {
			try {
				const { url, method, body, contentType } = payload;

				let response: Response;
				if (method === 'GET' || method === 'DELETE') {
					response = await fetch(url, {
						method,
					});
				} else {
					// const headers = {
					// 	['Content-Type']: 'application/json',
					// };
					// if (contentType) {
					// 	headers['Content-Type'] = contentType;
					// }
					response = await fetch(url, {
						method,
						// headers,
						body,
					});
				}

				// Callers read `res.error`, so every failure is returned in that shape.
				let res: any = null;
				try {
					res = await response.json();
				} catch (error) {
					return { error: `Request failed (${response.status}). Please try again.` };
				}

				if (!response.ok && !res?.error) {
					return { error: `Request failed (${response.status}). Please try again.` };
				}

				return res;
			} catch (error) {
				console.log('anonymousRequest', payload.url, error);
				return { error: 'Network error. Please check your connection and try again.' };
			}
		},
	}),
});
